export const findByKey = (object, key) => {
  const keys = Object.keys(object)

  if (keys.includes(key)) {
    return object[key]
  } else {
    for (let i = 0; i < keys.length; i++) {
      const innerKey = keys[i]
      let found = null

      if (_.isObject(object[innerKey])) {
        found = findByKey(object[innerKey], key)
      }

      if (!_.isNull(found) && !_.isUndefined(found)) {
        return found
      }
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/index.js